export let server={
    host:'https://api.letstrak.live'
};
